import React, { useState } from 'react'

// @material-ui/icons
import Tabs from '@components/Tabs'
import Axios from '@components/Axios'

import AddEditCompensation from './components/AddEditCompensation'

import './styles.scss'

const Compensation = () => {
  const [run, setRun] = useState(1)
  const [item, setItem] = useState({})

  const onSuccess = ({ data }) => {
    setItem(data)
  }

  const updateList = () => {
    setRun(run => run + 1)
  }

  const tabs = [
    {
      icon: 'add',
      name: 'COMPENSATION_TAB_ADD',
      content: <AddEditCompensation item={item} updateList={updateList} />
    }
  ]

  return (
    // <Axios run={run} api="pages.compensation" onSuccess={onSuccess}>
    <Axios run={run} api="pages.compensation" onSuccess={onSuccess}>
      <div className="Compensation">
        <Tabs headerColor="primary" tabs={tabs} />
      </div>
    </Axios>
  )
}

export default Compensation
